import {Controller} from "stimulus"

/**
 * Multi-select dropdown for jurisdiction filtering on the CD report page.
 *
 * When selections change, the trigger text is updated but the page does
 * NOT auto-navigate. The user clicks "Render Report" to load new data.
 */
export default class extends Controller {
    static get targets() {
        return ['trigger', 'triggerText', 'optionsWrapper', 'checkbox']
    }

    toggle(event) {
        event.preventDefault()
        if (this.triggerTarget.getAttribute('aria-expanded') === 'true') {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.triggerTarget.setAttribute('aria-expanded', 'true')
        this.optionsWrapperTarget.classList.add('dropdown__option-wrapper--visible')
    }

    close() {
        this.triggerTarget.setAttribute('aria-expanded', 'false')
        this.optionsWrapperTarget.classList.remove('dropdown__option-wrapper--visible')
    }

    closeOnOutsideClick(event) {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    selectionChanged() {
        this.updateTriggerText()
    }

    selectedIds() {
        return this.checkboxTargets
            .filter(cb => cb.checked)
            .map(cb => cb.value)
    }

    updateTriggerText() {
        const selected = this.checkboxTargets.filter(cb => cb.checked)
        if (selected.length === 0 || selected.length === this.checkboxTargets.length) {
            this.triggerTextTarget.innerText = ' All'
        } else {
            const names = selected.map(cb => cb.closest('label').textContent.trim())
            this.triggerTextTarget.innerText = ' ' + names.join(', ')
        }
    }
}
